export function referenceTools(item: PlaybookItem): PlaybookTool[] {
  return (item.references || []).map((reference, i) => ({ name: `reference_${i + 1}`, description: reference.description, run: async () => reference.text }))
}
